/**
 * Extend this union when introducing new capacity windows (e.g. 'month').
 * Must stay in sync with the copy in foodfluence_dashboard's shared package: the
 * dashboard writes these keys, this repo enforces them, and any period missing here
 * is silently dropped by normalizeSchedulingCapacityLimits.
 */
export const SCHEDULING_CAPACITY_PERIODS = ['slot', 'hour', 'day', 'week'] as const;
export type SchedulingCapacityPeriod = (typeof SCHEDULING_CAPACITY_PERIODS)[number];

/** Sparse map: omitted keys = unlimited for that period. Values must be >= 1 when set. */
export type SchedulingCapacityLimits = Partial<Record<SchedulingCapacityPeriod, number>>;
